import { PlanTypesEnum } from '@ctct/domain-layer';
import type { ComparisonTableFeature, ComparisonTableGroup } from '@ctct/payflow-ui';

import content from './content';
import marketingData from './marketingData';
import type { ContentStrategy } from '../ContentStrategy';

const idToTypeMap = {
  '1': PlanTypesEnum.Bronze,
  '2': PlanTypesEnum.Silver,
  '3': PlanTypesEnum.Gold,
};

/**
 * Content strategy for US/UK/NZ customers.
 *
 * Displays SMS Marketing without country-specific messaging, with US pricing ($10 USD).
 * Visibility is controlled at runtime by PlanComparisonTableService based on endpoint eligibility.
 *
 * See specs/sms-international.md for full details.
 */
export class PricingContentStrategy implements ContentStrategy {
  getInitialGroups(): ComparisonTableGroup[] {
    return content.groups.map((g) => ({
      ...g,
      features: g.features.map((f) => ({
        ...f,
        parameters: f.parameters.map((p) => ({ ...p, id: idToTypeMap[p.id] })),
      })),
    }));
  }

  getInitialPlans() {
    return content.headers.plans;
  }

  getStaticTableContent(): ComparisonTableFeature[] {
    return marketingData.features.slice(1).map((f) => ({
      ...f,
      parameters: f.parameters.map((p) => ({ ...p, id: idToTypeMap[p.id] })),
    }));
  }
}
